export default __webpack_public_path__ + "static/media/home.4fa66468.svg";